import { render } from "./PaymentChannelFormPage.vue?vue&type=template&id=2a16163e&ts=true"
import script from "./PaymentChannelFormPage.vue?vue&type=script&lang=ts"
export * from "./PaymentChannelFormPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__